import React, { useState, useEffect } from 'react';
import { Plus, Trash2 } from 'lucide-react';
import '../../styles/BillOfEntryTab.css';

const BillOfEntryTab = ({ data, masterData, onChange }) => {
    const [billItems, setBillItems] = useState(data || []);
    const shippingAgents = masterData.shippingAgents || [];

    useEffect(() => {
        setBillItems(data || []);
    }, [data]);

    const addNewRow = () => {
        const newRow = {
            BillOfEntryID: null,
            BillOfEntry: '',
            BillofEntryDate: new Date().toISOString().split('T')[0],
            ShippingAgentID: null
        };
        const updated = [...billItems, newRow];
        setBillItems(updated);
        onChange(updated);
    };

    const deleteRow = (index) => {
        if (window.confirm('Delete this bill of entry?')) {
            const updated = billItems.filter((_, i) => i !== index);
            setBillItems(updated);
            onChange(updated);
        }
    };

    const updateRow = (index, field, value) => {
        const updated = [...billItems];
        updated[index][field] = value;
        setBillItems(updated);
        onChange(updated);
    };

    return (
        <div className="bill-of-entry-tab">
            <div className="bill-toolbar">
                <button className="btn btn-primary btn-sm" onClick={addNewRow}>
                    <Plus size={16} />
                    Add Bill of Entry
                </button>
            </div>

            <div className="bill-grid-wrapper">
                <table className="bill-grid">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Bill of Entry No</th>
                            <th>Date</th>
                            <th>Shipping Agent</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {billItems.length === 0 ? (
                            <tr>
                                <td colSpan="5" className="empty-row">
                                    No bill of entry records. Click "Add Bill of Entry" to add.
                                </td>
                            </tr>
                        ) : (
                            billItems.map((row, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>
                                        <input
                                            type="text"
                                            value={row.BillOfEntry || ''}
                                            onChange={(e) => updateRow(index, 'BillOfEntry', e.target.value)}
                                            className="grid-input"
                                            placeholder="Bill of Entry No"
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="date"
                                            value={row.BillofEntryDate || ''}
                                            onChange={(e) => updateRow(index, 'BillofEntryDate', e.target.value)}
                                            className="grid-input"
                                        />
                                    </td>
                                    <td>
                                        <select
                                            value={row.ShippingAgentID || ''}
                                            onChange={(e) => updateRow(index, 'ShippingAgentID', parseInt(e.target.value))}
                                            className="grid-select"
                                        >
                                            <option value="">Select Agent</option>
                                            {shippingAgents.map(agent => (
                                                <option key={agent.id} value={agent.id}>{agent.name}</option>
                                            ))}
                                        </select>
                                    </td>
                                    <td>
                                        <button
                                            className="btn-icon btn-danger"
                                            onClick={() => deleteRow(index)}
                                            title="Delete"
                                        >
                                            <Trash2 size={16} />
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default BillOfEntryTab;